import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BASE_URL } from "./BaseUrl";
import websitelogo from "../assets/websitelogo.png";
import websitelogoes from "../assets/websitelogoes.png";
import { useTranslation } from "react-i18next";

export const useCompanyLogo = (token) => {
  const { i18n } = useTranslation();

 const user = useSelector((state) => state.auth.user);
 const companyId = user?.company_id; // ✅ Correct key

  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(true);

  const currentLang = i18n.language || "en";

  const blobToBase64 = (blob) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });

  const fetchImageBlob = async (url) => {
    try {
      const res = await fetch(url);
      if (!res.ok) return null;
      return await res.blob();
    } catch {
      return null;
    }
  };

  const fallbackFile = currentLang === "es" ? websitelogo:websitelogoes;

  const loadFallback = async () => {
    const blob = await fetch(fallbackFile).then((r) => r.blob());
    return blobToBase64(blob);
  };

  useEffect(() => {
    if (!companyId || !token) return;

    const loadLogo = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/company-admins/get-admin-theme-setting/${companyId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const json = await res.json();
        const logoUrl = json?.data?.logo;

        let base64 = null;

        if (logoUrl) {
          const blob = await fetchImageBlob(logoUrl);
          if (blob) base64 = await blobToBase64(blob);
        }

        if (!base64) base64 = await loadFallback();

        setLogo(base64);
      } catch (error) {
        const fallback = await loadFallback();
        setLogo(fallback);
      } finally {
        setLoading(false);
      }
    };

    loadLogo();
  }, [token, companyId, currentLang]);

  return { logo, loading };
};
